<template>
  <div
    class="patient-tag-input"
    :class="{ 'is-small': size === 'sm' }"
  >
    <div
      v-if="!options.length"
      class="small-text text-muted"
    >
      ยังไม่มีรายการ tag
    </div>
    <multiselect
      v-else
      :id="id"
      :value="selected"
      :options="options"
      :multiple="true"
      :searchable="true"
      :close-on-select="false"
      track-by="val"
      label="label"
      :placeholder="placeholder"
      select-label=""
      selected-label="✓"
      deselect-label=""
      @input="onInput"
    >
      <template #tag="{ option, remove }">
        <span
          class="badge patient-tag-chip"
          :class="chipClass(option)"
          >{{ option.label }}
          <i
            class="fas fa-times ml-1 patient-tag-remove"
            @mousedown.prevent
            @click="remove(option)"
          ></i>
        </span>
      </template>
      <template #noResult>ไม่พบรายการ</template>
    </multiselect>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { tagClass } from "@/utils/patientTags";

export default {
  name: "PatientTagInput",
  props: {
    value: { type: Array, default: () => [] },
    placeholder: { type: String, default: "เลือก tag…" },
    size: { type: String, default: "" },
    id: { type: String, default: undefined },
  },
  computed: {
    ...mapGetters({ tagList: "moduleMaster/getPatientTagList" }),
    options() {
      return this.tagList || [];
    },
    selected() {
      const ids = this.value || [];
      return this.options.filter(t => ids.includes(t.val));
    },
  },
  methods: {
    onInput(next) {
      // Keep ids whose tag was removed from the list, so editing the form
      // never drops them silently.
      const known = this.options.map(t => t.val);
      const unknown = (this.value || []).filter(id => !known.includes(id));
      this.$emit("input", [...unknown, ...(next || []).map(t => t.val)]);
    },
    chipClass(option) {
      return tagClass(option.color);
    },
  },
};
</script>

<style scoped>
.patient-tag-chip {
  display: inline-flex;
  align-items: center;
  margin: 0 4px 4px 0;
  font-size: 0.8rem;
}
.patient-tag-remove {
  cursor: pointer;
  font-size: 0.7rem;
}
.patient-tag-input.is-small ::v-deep .multiselect__tags {
  min-height: 31px;
  font-size: 0.875rem;
}
</style>
